import { faPlus, faEye, faEdit, faSave, faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from 'react-bootstrap/Table';
import { useState, useEffect } from 'react';
import './style.css';
import ToastNotification from '../../../components/toast_notification';
import { PermissionGate } from '../../../contexts/PermissionGate';
import { API_CONFIG } from '../../../config/api';

interface Fundo {
  id: number;
  cnpj: string;
  razao_social: string;
  nome_fantasia: string;
  data_inicio: string;
  data_fim: string;
  produto: string;
  administrador: string;
  ativo: boolean;
  codigo_carteira: string;
  usuario_aprovacao_cessao: string;
  usuario_batimento_carteira: string;
  nome_cota?: string;
  serie?: number;
  benchmark?: string;
  indexador?: string;
  valor_spread?: number;
  data_vencimento?: string;
}

interface UsuarioFundo {
  id: number;
  usuario_id: number;
  nome: string;
  relacao: 'aprovador_cessao' | 'batimento_cota';
  ativo: boolean;
}

const CadastroFundo = () => {
  const isAdmin = true;
  const [modais, setModais] = useState({
    novoFundo: false,
    edicaoFundo: false,
    confirmacaoSaida: false,
    usuariosFundo: false,
    edicaoFundoFundo: false,
    adicionarUsuario: false
  });

  const [loading, setLoading] = useState(false);
  const [produtos, setProdutos] = useState<Array<{ id: number, nome: string }>>([]);
  const [carregandoProdutos, setCarregandoProdutos] = useState(false);
  const [administradores, setAdministradores] = useState<Array<{ id: number, nome: string }>>([]);
  const [carregandoAdministradores, setCarregandoAdministradores] = useState(false);
  const [usuarios, setUsuarios] = useState<Array<{ id: number, nome: string }>>([]);
  const [carregandoUsuarios, setCarregandoUsuarios] = useState(false);
  const [usarMesmoUsuario, setUsarMesmoUsuario] = useState(false);
  const [usuariosFundo, setUsuariosFundo] = useState<UsuarioFundo[]>([]);
  const [fundoSelecionado, setFundoSelecionado] = useState<Fundo | null>(null);
  const [showToast, setShowToast] = useState(false);
  const [toastVariant, setToastVariant] = useState(200);
  const [toastMessage, setToastMessage] = useState('');
  const [novoUsuario, setNovoUsuario] = useState({
    usuario_id: '',
    relacao: 'aprovador_cessao' as 'aprovador_cessao' | 'batimento_cota'
  });
  const [dadosEdicaoFundo, setDadosEdicaoFundo] = useState<Fundo | null>(null);
  const [usuariosFundoEdicao, setUsuariosFundoEdicao] = useState<UsuarioFundo[]>([]);
  const [validacaoErroEdicao, setValidacaoErroEdicao] = useState({
    fundo: {
      razao_social: false,
      nome_fantasia: false,
      cnpj: false,
      data_inicio: false,
      data_fim: false,
      produto: false,
      administrador: false,
      codigo_carteira: false,
      usuario_aprovacao_cessao: false,
      usuario_batimento_carteira: false,
      nome_cota: false,
      serie: false,
      benchmark: false,
      indexador: false,
      valor_spread: false,
      data_vencimento: false
    },
    tentouSalvar: false
  });

  const buscarProdutos = async () => {
    setCarregandoProdutos(true);
    try {
      // Simulando dados já que não há API
      setProdutos([
        { id: 1, nome: 'FGTS' },
        { id: 2, nome: 'E-Consignado' },
        { id: 3, nome: 'Consignado Privado' },
        { id: 4, nome: 'Auto' },
        { id: 5, nome: 'Multiestrategia' }
      ]);
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
    } finally {
      setCarregandoProdutos(false);
    }
  };

  const buscarAdministradores = async () => {
    setCarregandoAdministradores(true);
    try {
      // Simulando dados já que não há API
      setAdministradores([
        { id: 1, nome: 'Banco Daycoval S.A.' },
        { id: 2, nome: 'Oliveira Trust S.A.' },
        { id: 3, nome: 'Banvox S.A.' }
      ]);
    } catch (error) {
      console.error('Erro ao buscar administradores:', error);
    } finally {
      setCarregandoAdministradores(false);
    }
  };

  const buscarUsuarios = async () => {
    setCarregandoUsuarios(true);
    try {
      // Simulando dados já que não há API
      setUsuarios([
        { id: 1, nome: 'João Silva' },
        { id: 2, nome: 'Maria Santos' },
        { id: 3, nome: 'Pedro Oliveira' },
        { id: 4, nome: 'Ana Costa' }
      ]);
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    } finally {
      setCarregandoUsuarios(false);
    }
  };

  useEffect(() => {
    buscarProdutos();
    buscarAdministradores();
    buscarUsuarios();
  }, []);

  const [dadosModais, setDadosModais] = useState({
    fundoParaEdicao: null as Fundo | null,
    novoFundo: {
      requester: '',
      razao_social: '',
      nome_fantasia: '',
      cnpj: '',
      data_inicio: '',
      data_fim: '',
      produto: '',
      administrador: '',
      codigo_carteira: '',
      usuario_aprovacao_cessao: '',
      usuario_batimento_carteira: '',
      nome_cota: '',
      serie: 0,
      benchmark: '',
      indexador: '',
      valor_spread: 0,
      data_vencimento: ''
    }
  });

  const abrirModalNovoFundo = () => {
    setDadosModais(prev => ({
      ...prev,
      novoFundo: {
        requester: '',
        razao_social: '',
        nome_fantasia: '',
        cnpj: '',
        data_inicio: '',
        data_fim: '',
        produto: '',
        administrador: '',
        codigo_carteira: '',
        usuario_aprovacao_cessao: '',
        usuario_batimento_carteira: '',
        nome_cota: '',
        serie: 0,
        benchmark: '',
        indexador: '',
        valor_spread: 0,
        data_vencimento: ''
      }
    }));
    abrirModal('novoFundo');
  };

  const abrirModal = (tipoModal: keyof typeof modais, dados?: any) => {
    setModais(prev => ({ ...prev, [tipoModal]: true }));

    if (dados) {
      setDadosModais(prev => ({
        ...prev,
        ...dados
      }));
    }
  };

  const mockData: Fundo[] = [
    {
      id: 1,
      cnpj: '11.111.111/1111-11',
      razao_social: 'Fundo 1',
      nome_fantasia: 'Fundo 1',
      data_inicio: '2021-01-01',
      data_fim: '2021-01-01',
      produto: 'FGTS',
      administrador: 'Administrador 1',
      ativo: true,
      codigo_carteira: '123456',
      usuario_aprovacao_cessao: 'João Silva',
      usuario_batimento_carteira: 'Maria Santos',
      nome_cota: 'Classe A',
      serie: 1,
      benchmark: 'CDI',
      indexador: 'IPCA',
      valor_spread: 1.5,
      data_vencimento: '2025-12-31'
    }
  ];

  const [validacaoErro, setValidacaoErro] = useState({
    fundo: {
      razao_social: false,
      nome_fantasia: false,
      cnpj: false,
      data_inicio: false,
      data_fim: false,
      produto: false,
      administrador: false,
      codigo_carteira: false,
      usuario_aprovacao_cessao: false,
      usuario_batimento_carteira: false,
      nome_cota: false,
      serie: false,
      benchmark: false,
      indexador: false,
      valor_spread: false,
      data_vencimento: false
    },
    tentouSalvar: false
  });

  const fecharModal = (tipoModal: keyof typeof modais) => {
    setModais(prev => ({ ...prev, [tipoModal]: false }));

    if (tipoModal === 'novoFundo') {
      setDadosModais(prev => ({
        ...prev,
        novoFundo: {
          requester: '',
          razao_social: '',
          nome_fantasia: '',
          cnpj: '',
          data_inicio: '',
          data_fim: '',
          produto: '',
          administrador: '',
          codigo_carteira: '',
          usuario_aprovacao_cessao: '',
          usuario_batimento_carteira: '',
          nome_cota: '',
          serie: 0,
          benchmark: '',
          indexador: '',
          valor_spread: 0,
          data_vencimento: ''
        }
      }));
      setValidacaoErro(prev => ({ ...prev, tentouSalvar: false }));
    }
  };

  const handleInputChange = (tipo: 'edicao' | 'novoFundo', field: string, value: string | boolean | number) => {
    if (tipo === 'novoFundo') {
      setDadosModais(prev => ({
        ...prev,
        novoFundo: {
          ...prev.novoFundo,
          [field]: value
        }
      }));
    }
  };

  const handleUsarMesmoUsuario = (checked: boolean) => {
    setUsarMesmoUsuario(checked);
    if (checked) {
      setDadosModais(prev => ({
        ...prev,
        novoFundo: {
          ...prev.novoFundo,
          usuario_batimento_carteira: prev.novoFundo.usuario_aprovacao_cessao
        }
      }));
    }
  };

  const handleUsuarioAprovacaoChange = (value: string) => {
    handleInputChange('novoFundo', 'usuario_aprovacao_cessao', value);
    if (usarMesmoUsuario) {
      handleInputChange('novoFundo', 'usuario_batimento_carteira', value);
    }
  };

  const validarFundo = () => {
    const { razao_social, nome_fantasia, cnpj, data_inicio, produto, administrador, codigo_carteira, usuario_aprovacao_cessao, usuario_batimento_carteira, nome_cota, serie, benchmark, indexador, valor_spread, data_vencimento } = dadosModais.novoFundo;

    const camposObrigatorios = razao_social.trim() !== '' && nome_fantasia.trim() !== '' && cnpj.trim() !== '' &&
      data_inicio.trim() !== '' && produto.trim() !== '' && administrador.trim() !== '' &&
      codigo_carteira.trim() !== '' && usuario_aprovacao_cessao.trim() !== '' && usuario_batimento_carteira.trim() !== '';

    const camposClassesCotas = nome_cota.trim() !== '' && serie > 0 && benchmark.trim() !== '' &&
      indexador.trim() !== '' && valor_spread > 0 && data_vencimento.trim() !== '';

    const hoje = new Date().toISOString().split('T')[0];
    const dataVencimentoValida = data_vencimento && data_vencimento > hoje;

    return camposObrigatorios && camposClassesCotas && dataVencimentoValida;
  };

  const salvarNovoFundo = async () => {
    dadosModais.novoFundo.requester = localStorage.getItem('id_usuario') || '';
    setValidacaoErro(prev => ({ ...prev, tentouSalvar: true }));

    const fundoValido = validarFundo();
    console.log(fundoValido);
    
    if (fundoValido) {
      try {
        setLoading(true);
        console.log(dadosModais.novoFundo);
        const response = await fetch(`${API_CONFIG.BASE_URL}/fundo/cadastrar`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dadosModais.novoFundo)
        });
        
        if (!response.ok) {
          const errorData = await response.json().catch(() => null);
          throw new Error(errorData?.message || 'Erro ao cadastrar o fundo');
        }
        const responseData = await response.json();
        fecharModal('novoFundo');
        setLoading(false);
        setToastVariant(200);
        setToastMessage(`Fundo "${dadosModais.novoFundo.nome_fantasia}" cadastrado com sucesso!`);
        setShowToast(true);
      } catch (error) {
        console.error('Erro ao salvar fundo:', error);
        setLoading(false);
        setToastVariant(500);
        const errorMessage = error instanceof Error ? error.message : 'Erro inesperado';
        setToastMessage(`Falha ao cadastrar o fundo: ${errorMessage}`);
        setShowToast(true);
      }
      } else {
        const hoje = new Date().toISOString().split('T')[0];
        const novosErros = {
          fundo: {
            razao_social: dadosModais.novoFundo.razao_social.trim() === '',
            nome_fantasia: dadosModais.novoFundo.nome_fantasia.trim() === '',
            cnpj: dadosModais.novoFundo.cnpj.trim() === '',
            data_inicio: dadosModais.novoFundo.data_inicio.trim() === '',
            data_fim: dadosModais.novoFundo.data_fim.trim() === '',
            produto: dadosModais.novoFundo.produto.trim() === '',
            administrador: dadosModais.novoFundo.administrador.trim() === '',
            codigo_carteira: dadosModais.novoFundo.codigo_carteira.trim() === '',
            usuario_aprovacao_cessao: dadosModais.novoFundo.usuario_aprovacao_cessao.trim() === '',
            usuario_batimento_carteira: dadosModais.novoFundo.usuario_batimento_carteira.trim() === '',
            nome_cota: dadosModais.novoFundo.nome_cota.trim() === '',
            serie: dadosModais.novoFundo.serie <= 0,
            benchmark: dadosModais.novoFundo.benchmark.trim() === '',
            indexador: dadosModais.novoFundo.indexador.trim() === '',
            valor_spread: dadosModais.novoFundo.valor_spread <= 0,
            data_vencimento: dadosModais.novoFundo.data_vencimento.trim() === '' || dadosModais.novoFundo.data_vencimento <= hoje
          },
          tentouSalvar: true
        };

        setValidacaoErro(novosErros);
        
        setToastVariant(400);
        setToastMessage("Por favor, preencha todos os campos obrigatórios corretamente");
        setShowToast(true);
      }
  };

  const abrirModalUsuarios = (item: Fundo) => {
    setFundoSelecionado(item);
    setUsuariosFundo([
      {
        id: 1,
        usuario_id: 1,
        nome: 'João Silva',
        relacao: 'aprovador_cessao',
        ativo: true
      },
      {
        id: 2,
        usuario_id: 2,
        nome: 'Maria Santos',
        relacao: 'batimento_cota',
        ativo: true
      }
    ]);
    abrirModal('usuariosFundo');
  };

  const abrirModalEdicaoFundo = (item: Fundo) => {
    const dadosInicializados = {
      ...item,
      nome_cota: item.nome_cota || '',
      serie: item.serie || 0,
      benchmark: item.benchmark || '',
      indexador: item.indexador || '',
      valor_spread: item.valor_spread || 0,
      data_vencimento: item.data_vencimento || ''
    };
    setDadosEdicaoFundo(dadosInicializados);
    setUsuariosFundoEdicao([
      {
        id: 1,
        usuario_id: 1,
        nome: 'João Silva',
        relacao: 'aprovador_cessao',
        ativo: true
      },
      {
        id: 2,
        usuario_id: 2,
        nome: 'Maria Santos',
        relacao: 'batimento_cota',
        ativo: true
      }
    ]);
    setValidacaoErroEdicao(prev => ({ ...prev, tentouSalvar: false }));
    abrirModal('edicaoFundoFundo');
  };

  const toggleUsuarioAtivo = (usuarioId: number) => {
    setUsuariosFundo(prev =>
      prev.map(usuario =>
        usuario.id === usuarioId
          ? { ...usuario, ativo: !usuario.ativo }
          : usuario
      )
    );
  };

  const excluirUsuario = (usuarioId: number) => {
    setUsuariosFundo(prev => prev.filter(usuario => usuario.id !== usuarioId));
  };

  const adicionarUsuario = () => {
    if (novoUsuario.usuario_id) {
      const usuarioSelecionado = usuarios.find(u => u.id.toString() === novoUsuario.usuario_id);
      if (usuarioSelecionado) {
        const novoUsuarioFundo: UsuarioFundo = {
          id: Date.now(),
          usuario_id: parseInt(novoUsuario.usuario_id),
          nome: usuarioSelecionado.nome,
          relacao: novoUsuario.relacao,
          ativo: true
        };

        if (modais.edicaoFundoFundo) {
          setUsuariosFundoEdicao(prev => [...prev, novoUsuarioFundo]);
        } else {
          setUsuariosFundo(prev => [...prev, novoUsuarioFundo]);
        }

        setNovoUsuario({ usuario_id: '', relacao: 'aprovador_cessao' });
        fecharModal('adicionarUsuario');
      }
    }
  };

  const abrirModalAdicionarUsuario = () => {
    abrirModal('adicionarUsuario');
  };

  const handleInputChangeEdicao = (field: string, value: string | boolean | number) => {
    setDadosEdicaoFundo(prev => {
      if (!prev) return null;
      return {
        ...prev,
        [field]: value
      };
    });
  };

  const toggleUsuarioAtivoEdicao = (usuarioId: number) => {
    setUsuariosFundoEdicao(prev =>
      prev.map(usuario =>
        usuario.id === usuarioId
          ? { ...usuario, ativo: !usuario.ativo }
          : usuario
      )
    );
  };

  const excluirUsuarioEdicao = (usuarioId: number) => {
    setUsuariosFundoEdicao(prev => prev.filter(usuario => usuario.id !== usuarioId));
  };

  const validarFundoEdicao = () => {
    if (!dadosEdicaoFundo) return false;
    const { razao_social, nome_fantasia, cnpj, data_inicio, data_fim, produto, administrador, codigo_carteira, usuario_aprovacao_cessao, usuario_batimento_carteira, nome_cota, serie, benchmark, indexador, valor_spread, data_vencimento } = dadosEdicaoFundo;

    // Validação básica dos campos obrigatórios
    const camposObrigatorios = razao_social.trim() !== '' && nome_fantasia.trim() !== '' && cnpj.trim() !== '' &&
      data_inicio.trim() !== '' && data_fim.trim() !== '' && produto.trim() !== '' && administrador.trim() !== '' &&
      codigo_carteira.trim() !== '' && usuario_aprovacao_cessao.trim() !== '' && usuario_batimento_carteira.trim() !== '';

    // Validação dos campos de classes/cotas (obrigatórios)
    const camposClassesCotas = nome_cota?.trim() !== '' && serie && serie > 0 && benchmark?.trim() !== '' &&
      indexador?.trim() !== '' && valor_spread && valor_spread > 0 && data_vencimento?.trim() !== '';

    // Validação da data de vencimento (deve ser maior que hoje)
    const hoje = new Date().toISOString().split('T')[0];
    const dataVencimentoValida = data_vencimento && data_vencimento > hoje;

    return camposObrigatorios && camposClassesCotas && dataVencimentoValida;
  };

  const salvarEdicaoFundo = () => {
    if (!dadosEdicaoFundo) return;

    setValidacaoErroEdicao(prev => ({ ...prev, tentouSalvar: true }));

    const fundoValido = validarFundoEdicao();

    if (fundoValido) {
      console.log('Salvando edição do fundo:', {
        fundo: dadosEdicaoFundo,
        usuarios: usuariosFundoEdicao
      });
      fecharModal('edicaoFundoFundo');
    } else {
      const hoje = new Date().toISOString().split('T')[0];
      const novosErros = {
        fundo: {
          razao_social: dadosEdicaoFundo.razao_social.trim() === '',
          nome_fantasia: dadosEdicaoFundo.nome_fantasia.trim() === '',
          cnpj: dadosEdicaoFundo.cnpj.trim() === '',
          data_inicio: dadosEdicaoFundo.data_inicio.trim() === '',
          data_fim: dadosEdicaoFundo.data_fim.trim() === '',
          produto: dadosEdicaoFundo.produto.trim() === '',
          administrador: dadosEdicaoFundo.administrador.trim() === '',
          codigo_carteira: dadosEdicaoFundo.codigo_carteira.trim() === '',
          usuario_aprovacao_cessao: dadosEdicaoFundo.usuario_aprovacao_cessao.trim() === '',
          usuario_batimento_carteira: dadosEdicaoFundo.usuario_batimento_carteira.trim() === '',
          nome_cota: dadosEdicaoFundo.nome_cota?.trim() === '',
          serie: !dadosEdicaoFundo.serie || dadosEdicaoFundo.serie <= 0,
          benchmark: dadosEdicaoFundo.benchmark?.trim() === '',
          indexador: dadosEdicaoFundo.indexador?.trim() === '',
          valor_spread: !dadosEdicaoFundo.valor_spread || dadosEdicaoFundo.valor_spread <= 0,
          data_vencimento: !dadosEdicaoFundo.data_vencimento || dadosEdicaoFundo.data_vencimento.trim() === '' || dadosEdicaoFundo.data_vencimento <= hoje
        },
        tentouSalvar: true
      };

      setValidacaoErroEdicao(novosErros);
    }
  };

  return (
    <ErrorBoundary>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h5 className="card-title">Cadastro de Fundos</h5>
        <PermissionGate required="REGISTER_FUNDS">
          <button
            className="fn-button fn-button--emphasized"
            onClick={abrirModalNovoFundo}
          >
            <div className="fn-button__text">
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
              Novo Fundo
            </div>
          </button>
        </PermissionGate>
      </div>
      <Table>
        <thead>
          <tr>
            <th>CNPJ</th>
            <th>Razão Social</th>
            <th>Nome Fantasia</th>
            <th>Produto</th>
            <th>Administrador</th>
            <th>Situação</th>
            <th>Data Início</th>
            <th>Data Fim</th>
            <th>Usuários</th>
            <th>Editar</th>
          </tr>
        </thead>
        <tbody>
          {mockData.map((item, index) => (
            <tr key={index}>
              <td>{item.cnpj}</td>
              <td>{item.razao_social}</td>
              <td>{item.nome_fantasia}</td>
              <td>{item.produto}</td>
              <td>{item.administrador}</td>
              <td>
                <span className={`badge ${item.ativo ? 'ativo' : 'inativo'}`}>
                  {item.ativo ? 'Ativo' : 'Inativo'}
                </span>
              </td>
              <td>{item.data_inicio}</td>
              <td>{item.data_fim}</td>
              <td>
                <button
                  className="fn-button fn-button--icon fn-button--secondary"
                  onClick={() => abrirModalUsuarios(item)}
                  title="Ver usuários"
                >
                  <div className="fn-button__text">
                    <FontAwesomeIcon icon={faEye} />
                  </div>
                </button>
              </td>
              <td>
                <PermissionGate required="UPDATE_FUNDS">
                  <button
                    className="fn-button fn-button--icon fn-button--secondary"
                    onClick={() => abrirModalEdicaoFundo(item)}
                    title="Editar fundo"
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faEdit} />
                    </div>
                  </button>
                </PermissionGate>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal Novo Fundo */}
      <PermissionGate required="REGISTER_FUNDS"> 
      {modais.novoFundo && (
        <div className="modal-overlay" onClick={() => fecharModal('novoFundo')}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Novo Fundo</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('novoFundo')}
                title="Fechar"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
               {loading ? (
                 <div className="loading-container">
                   <div className="fiori-spinner"></div>
                   <span className="loading-text">Salvando fundo...</span>
                 </div>
               ) : (
                <>
                <div className="form-section">
                  <h4 className="section-title">Dados do Fundo</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Razão Social</label>
                      <input
                        type="text"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.razao_social ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.razao_social}
                        onChange={(e) => handleInputChange('novoFundo', 'razao_social', e.target.value)}
                        placeholder="Digite a razão social"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Nome Fantasia</label>
                      <input
                        type="text"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.nome_fantasia ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.nome_fantasia}
                        onChange={(e) => handleInputChange('novoFundo', 'nome_fantasia', e.target.value)}
                        placeholder="Digite o nome fantasia"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">CNPJ</label>
                      <input
                        type="text"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.cnpj ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.cnpj}
                        onChange={(e) => handleInputChange('novoFundo', 'cnpj', e.target.value)}
                        placeholder="00.000.000/0000-00"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Data Início</label>
                      <input
                        type="date"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.data_inicio ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.data_inicio}
                        onChange={(e) => handleInputChange('novoFundo', 'data_inicio', e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Produto</label>
                      <select
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.produto ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.produto}
                        onChange={(e) => handleInputChange('novoFundo', 'produto', e.target.value)}
                        required
                        disabled={carregandoProdutos}
                      >
                        <option value="">
                          {carregandoProdutos ? 'Carregando produtos...' : 'Selecione um produto'}
                        </option>
                        {produtos.map((produto) => (
                          <option key={produto.id} value={produto.nome}>
                            {produto.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                    </div>
                  </div>
                </div>
                <div className="form-section">
                  <h4 className="section-title">Informações administrador</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Administrador</label>
                      <select
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.administrador ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.administrador}
                        onChange={(e) => handleInputChange('novoFundo', 'administrador', e.target.value)}
                        required
                        disabled={carregandoAdministradores}
                      >
                        <option value="">
                          {carregandoAdministradores ? 'Carregando administradores...' : 'Selecione um administrador'}
                        </option>
                        {administradores.map((administrador) => (
                          <option key={administrador.id} value={administrador.nome}>
                            {administrador.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Código carteira</label>
                      <input
                        type="text"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.codigo_carteira ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.codigo_carteira}
                        onChange={(e) => handleInputChange('novoFundo', 'codigo_carteira', e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h4 className="section-title">Informações usuários</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Usuário responsável por aprovação de cessão</label>
                      <select
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.usuario_aprovacao_cessao ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.usuario_aprovacao_cessao}
                        onChange={(e) => handleUsuarioAprovacaoChange(e.target.value)}
                        required
                        disabled={carregandoUsuarios}
                      >
                        <option value="">
                          {carregandoUsuarios ? 'Carregando usuários...' : 'Selecione um usuário'}
                        </option>
                        {usuarios.map((usuario) => (
                          <option key={usuario.id} value={usuario.nome}>
                            {usuario.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Usuário responsável por batimento de carteira</label>
                      <select
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.usuario_batimento_carteira ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.usuario_batimento_carteira}
                        onChange={(e) => handleInputChange('novoFundo', 'usuario_batimento_carteira', e.target.value)}
                        required
                        disabled={carregandoUsuarios || usarMesmoUsuario}
                      >
                        <option value="">
                          {carregandoUsuarios ? 'Carregando usuários...' : 'Selecione um usuário'}
                        </option>
                        {usuarios.map((usuario) => (
                          <option key={usuario.id} value={usuario.nome}>
                            {usuario.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={usarMesmoUsuario}
                          onChange={(e) => handleUsarMesmoUsuario(e.target.checked)}
                        />
                        <span className="checkbox-text">Usar o mesmo usuário para ambas as responsabilidades</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <h4 className="section-title">Informações classes/cotas</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Nome</label>
                      <input
                        type="text"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.nome_cota ? 'form-input--error' : ''}`}
                        maxLength={10}
                        value={dadosModais.novoFundo.nome_cota}
                        onChange={(e) => handleInputChange('novoFundo', 'nome_cota', e.target.value)}
                        required
                      />
                    </div>
                     <div className="form-group">
                       <label className="form-label form-label--required">Série</label>
                       <input
                         type="number"
                         className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.serie ? 'form-input--error' : ''}`}
                         value={dadosModais.novoFundo.serie}
                         onChange={(e) => handleInputChange('novoFundo', 'serie', parseInt(e.target.value) || 0)}
                         required
                       />
                       {validacaoErro.tentouSalvar && validacaoErro.fundo.serie && (
                         <span className="form-error">A série deve ser um número maior que zero</span>
                       )}
                     </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label className="form-label form-label--required">Benchmark</label>
                      <input
                        type="text"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.benchmark ? 'form-input--error' : ''}`}
                        maxLength={45}
                        value={dadosModais.novoFundo.benchmark}
                        onChange={(e) => handleInputChange('novoFundo', 'benchmark', e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label form-label--required">Indexador</label>
                      <input
                        type="text"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.indexador ? 'form-input--error' : ''}`}
                        maxLength={45}
                        value={dadosModais.novoFundo.indexador}
                        onChange={(e) => handleInputChange('novoFundo', 'indexador', e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                     <div className="form-group">
                       <label className="form-label form-label--required">Valor Spread</label>
                       <input
                         type="number"
                         step="0.01"
                         className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.valor_spread ? 'form-input--error' : ''}`}
                         value={dadosModais.novoFundo.valor_spread}
                         onChange={(e) => handleInputChange('novoFundo', 'valor_spread', parseFloat(e.target.value))}
                         required
                       />
                       {validacaoErro.tentouSalvar && validacaoErro.fundo.valor_spread && (
                         <span className="form-error">O valor spread deve ser maior que zero</span>
                       )}
                     </div>
                    <div className="form-group">
                      <label className="form-label">Data Vencimento</label>
                      <input
                        type="date"
                        className={`form-input ${validacaoErro.tentouSalvar && validacaoErro.fundo.data_vencimento ? 'form-input--error' : ''}`}
                        value={dadosModais.novoFundo.data_vencimento}
                        onChange={(e) => handleInputChange('novoFundo', 'data_vencimento', e.target.value)}
                        min={new Date().toISOString().split('T')[0]}
                      />
                    {validacaoErro.tentouSalvar && validacaoErro.fundo.data_vencimento && (
                      <span className="form-error">A data de vencimento deve ser maior que hoje</span>
                    )}
                    </div>
                  </div>
                </div>
              </>
              )}
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('novoFundo')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarNovoFundo}
                disabled={loading}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  {loading ? 'Salvando...' : 'Salvar'}
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
      </PermissionGate>
      {/* Modal de Usuários do Fundo */}
      {modais.usuariosFundo && (
        <div className="modal-overlay" onClick={() => fecharModal('usuariosFundo')}>
          <div className="modal-content modal-content--large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">
                Usuários do Fundo - {fundoSelecionado?.nome_fantasia}
              </h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('usuariosFundo')}
                title="Fechar"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="form-section">
                <Table>
                  <thead>
                    <tr>
                      <th>Nome do Usuário</th>
                      <th>Relação</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuariosFundo.map((usuario) => (
                      <tr key={usuario.id}>
                        <td>{usuario.nome}</td>
                        <td>
                          <span className={`badge ${usuario.relacao === 'aprovador_cessao' ? 'badge--primary' : 'badge--secondary'}`}>
                            {usuario.relacao === 'aprovador_cessao' ? 'Aprovador de Cessão' : 'Batimento de Cota'}
                          </span>
                        </td>
                        <td>
                          <label className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={usuario.ativo}
                              onChange={() => toggleUsuarioAtivo(usuario.id)}
                            />
                            <span className="checkbox-text">
                              {usuario.ativo ? 'Ativo' : 'Inativo'}
                            </span>
                          </label>
                        </td>
                        <td>
                          <PermissionGate required="UPDATE_FUNDS">
                          <button
                            className="fn-button fn-button--icon fn-button--secondary fn-button--danger"
                            onClick={() => excluirUsuario(usuario.id)}
                            title="Excluir usuário"
                          >
                            <div className="fn-button__text">
                              <FontAwesomeIcon icon={faTrash} />
                            </div>
                          </button>
                          </PermissionGate>
                        </td>
                      </tr>
                    ))}
                    {usuariosFundo.length === 0 && (
                      <tr>
                        <td colSpan={4} className="empty-state">
                          Nenhum usuário associado a este fundo
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="modal-footer">
              <PermissionGate required="UPDATE_FUNDS">
              <button
                className="fn-button fn-button--emphasized"
                onClick={abrirModalAdicionarUsuario}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faUserPlus} style={{ marginRight: '8px' }} />
                  Adicionar Usuário
                  </div>
                </button>
              </PermissionGate>
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('usuariosFundo')}
              >
                <div className="fn-button__text">Fechar</div>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para Adicionar Usuário */}
      {modais.adicionarUsuario && (
        <div className="modal-overlay modal-overlay--tertiary" onClick={() => fecharModal('adicionarUsuario')}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Adicionar Usuário ao Fundo</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('adicionarUsuario')}
                title="Fechar"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="form-section">
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Usuário</label>
                    <select
                      className="form-input"
                      value={novoUsuario.usuario_id}
                      onChange={(e) => setNovoUsuario(prev => ({ ...prev, usuario_id: e.target.value }))}
                      required
                      disabled={carregandoUsuarios}
                    >
                      <option value="">
                        {carregandoUsuarios ? 'Carregando usuários...' : 'Selecione um usuário'}
                      </option>
                      {usuarios.map((usuario) => (
                        <option key={usuario.id} value={usuario.id}>
                          {usuario.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Relação</label>
                    <select
                      className="form-input"
                      value={novoUsuario.relacao}
                      onChange={(e) => setNovoUsuario(prev => ({
                        ...prev,
                        relacao: e.target.value as 'aprovador_cessao' | 'batimento_cota'
                      }))}
                      required
                    >
                      <option value="aprovador_cessao">Aprovador de Cessão</option>
                      <option value="batimento_cota">Batimento de Cota</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('adicionarUsuario')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={adicionarUsuario}
                disabled={!novoUsuario.usuario_id}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faUserPlus} style={{ marginRight: '8px' }} />
                  Adicionar
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Edição do Fundo */}
      {modais.edicaoFundoFundo && dadosEdicaoFundo && (
        <div className="modal-overlay modal-overlay--secondary" onClick={() => fecharModal('edicaoFundoFundo')}>
          <div className="modal-content modal-content--large modal-edicao" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Editar Fundo</h3>
              <button
                className="modal-close"
                onClick={() => fecharModal('edicaoFundoFundo')}
                title="Fechar"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="form-section">
                <h4 className="section-title">Dados do Fundo</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Razão Social</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.razao_social ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.razao_social}
                      onChange={(e) => handleInputChangeEdicao('razao_social', e.target.value)}
                      placeholder="Digite a razão social"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Nome Fantasia</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.nome_fantasia ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.nome_fantasia}
                      onChange={(e) => handleInputChangeEdicao('nome_fantasia', e.target.value)}
                      placeholder="Digite o nome fantasia"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">CNPJ</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.cnpj ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.cnpj}
                      onChange={(e) => handleInputChangeEdicao('cnpj', e.target.value)}
                      placeholder="00.000.000/0000-00"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Data Início</label>
                    <input
                      type="date"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.data_inicio ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.data_inicio}
                      onChange={(e) => handleInputChangeEdicao('data_inicio', e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Data Fim</label>
                    <input
                      type="date"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.data_fim ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.data_fim}
                      onChange={(e) => handleInputChangeEdicao('data_fim', e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Produto</label>
                    <select
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.produto ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.produto}
                      onChange={(e) => handleInputChangeEdicao('produto', e.target.value)}
                      required
                      disabled={carregandoProdutos}
                    >
                      <option value="">
                        {carregandoProdutos ? 'Carregando produtos...' : 'Selecione um produto'}
                      </option>
                      {produtos.map((produto) => (
                        <option key={produto.id} value={produto.nome}>
                          {produto.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-section">
                <h4 className="section-title">Informações Administrador</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Administrador</label>
                    <select
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.administrador ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.administrador}
                      onChange={(e) => handleInputChangeEdicao('administrador', e.target.value)}
                      required
                      disabled={carregandoAdministradores}
                    >
                      <option value="">
                        {carregandoAdministradores ? 'Carregando administradores...' : 'Selecione um administrador'}
                      </option>
                      {administradores.map((administrador) => (
                        <option key={administrador.id} value={administrador.nome}>
                          {administrador.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Código Carteira</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.codigo_carteira ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo.codigo_carteira}
                      onChange={(e) => handleInputChangeEdicao('codigo_carteira', e.target.value)}
                      placeholder="Digite o código da carteira"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="form-section">
                <h4 className="section-title">Informações classes/cotas</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Nome</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.nome_cota ? 'form-input--error' : ''}`}
                      maxLength={10}
                      value={dadosEdicaoFundo?.nome_cota || ''}
                      onChange={(e) => handleInputChangeEdicao('nome_cota', e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Série</label>
                    <input
                      type="number"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.serie ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo?.serie || 0}
                      onChange={(e) => handleInputChangeEdicao('serie', parseInt(e.target.value) || 0)}
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Benchmark</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.benchmark ? 'form-input--error' : ''}`}
                      maxLength={45}
                      value={dadosEdicaoFundo?.benchmark || ''}
                      onChange={(e) => handleInputChangeEdicao('benchmark', e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label form-label--required">Indexador</label>
                    <input
                      type="text"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.indexador ? 'form-input--error' : ''}`}
                      maxLength={45}
                      value={dadosEdicaoFundo?.indexador || ''}
                      onChange={(e) => handleInputChangeEdicao('indexador', e.target.value)}
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label className="form-label form-label--required">Valor Spread</label>
                    <input
                      type="number"
                      step="0.01"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.valor_spread ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo?.valor_spread || 0}
                      onChange={(e) => handleInputChangeEdicao('valor_spread', parseFloat(e.target.value) || 0)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Data Vencimento</label>
                    <input
                      type="date"
                      className={`form-input ${validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.data_vencimento ? 'form-input--error' : ''}`}
                      value={dadosEdicaoFundo?.data_vencimento || ''}
                      onChange={(e) => handleInputChangeEdicao('data_vencimento', e.target.value)}
                      min={new Date().toISOString().split('T')[0]}
                    />
                    {validacaoErroEdicao.tentouSalvar && validacaoErroEdicao.fundo.data_vencimento && (
                      <span className="form-error">A data de vencimento deve ser maior que hoje</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-section usuarios-section">
                <h4 className="section-title">Usuários do Fundo</h4>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                  <span>Gerenciar usuários associados a este fundo</span>
                  <button
                    className="fn-button fn-button--emphasized"
                    onClick={abrirModalAdicionarUsuario}
                  >
                    <div className="fn-button__text">
                      <FontAwesomeIcon icon={faUserPlus} style={{ marginRight: '8px' }} />
                      Adicionar Usuário
                    </div>
                  </button>
                </div>

                <Table>
                  <thead>
                    <tr>
                      <th>Nome do Usuário</th>
                      <th>Relação</th>
                      <th>Status</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuariosFundoEdicao.map((usuario) => (
                      <tr key={usuario.id}>
                        <td>{usuario.nome}</td>
                        <td>
                          <span className={`badge ${usuario.relacao === 'aprovador_cessao' ? 'badge--primary' : 'badge--secondary'}`}>
                            {usuario.relacao === 'aprovador_cessao' ? 'Aprovador de Cessão' : 'Batimento de Cota'}
                          </span>
                        </td>
                        <td>
                          <label className="checkbox-label">
                            <input
                              type="checkbox"
                              checked={usuario.ativo}
                              onChange={() => toggleUsuarioAtivoEdicao(usuario.id)}
                            />
                            <span className="checkbox-text">
                              {usuario.ativo ? 'Ativo' : 'Inativo'}
                            </span>
                          </label>
                        </td>
                        <td>
                          <button
                            className="fn-button fn-button--icon fn-button--secondary fn-button--danger"
                            onClick={() => excluirUsuarioEdicao(usuario.id)}
                            title="Excluir usuário"
                          >
                            <div className="fn-button__text">
                              <FontAwesomeIcon icon={faTrash} />
                            </div>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {usuariosFundoEdicao.length === 0 && (
                      <tr>
                        <td colSpan={4} className="empty-state">
                          Nenhum usuário associado a este fundo
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="fn-button fn-button--secondary"
                onClick={() => fecharModal('edicaoFundoFundo')}
              >
                <div className="fn-button__text">Cancelar</div>
              </button>
              <button
                className="fn-button fn-button--emphasized"
                onClick={salvarEdicaoFundo}
              >
                <div className="fn-button__text">
                  <FontAwesomeIcon icon={faSave} style={{ marginRight: '8px' }} />
                  Salvar Alterações
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
      {showToast && <ToastNotification status={toastVariant} message={toastMessage} onClose={() => setShowToast(false)} />}
    </ErrorBoundary>
  );
};

export default CadastroFundo;